import $ from 'jquery'
import { lockBody, unlockBody } from './utiils'

const openMenu = () => {
  document.querySelector('.main-navigation').classList.add('active')
  lockBody()
}

const closeMenu = () => {
  document.querySelector('.main-navigation').classList.remove('active')
  unlockBody()
}

const submenuCloser = $('.submenu-closer')

$('.main-navigation .back').on('click', function () {
  $(this).parent().parent().removeClass('active')
  submenuCloser.removeClass('active')
})

$('.main-navigation .menu-item-has-children > a').on('click', function (e) {
  if (window.matchMedia('(max-width: 991.98px').matches) {
    e.preventDefault()

    $(this).parent().find('ul').eq(0).addClass('active')
    submenuCloser.addClass('active')
  }
})

submenuCloser.on('click', function () {
  $('.main-navigation .sub-menu').removeClass('active')
  submenuCloser.removeClass('active')
})

document.querySelector('.menu-opener').addEventListener('click', openMenu)
document.querySelector('.menu-closer').addEventListener('click', closeMenu)
